import React from "react";
import {render} from "react-dom";

import Contacts from "./Contacts/Contacts";
import Accounts from "./Accounts";
import CruiseControl from "./CruiseControl/CruiseControl";

import {Link } from 'react-router-dom';

export default function SideNabar() {

    return(
        
            <nav className=" w-full h-full">
                <div>
                    <div>
                        <div className="p-5 text-xs text-white uppercase font-bold"></div>
                    </div>

                    <div className="flex m-5 mt-2">
                        <div>
                            <img className="w-7 h-7" src="/assets/icons/account.png" alt="" />
                        </div>
                        <Link to="/accounts/"><div className="mx-3 text-base text-gray-100">Accounts</div></Link>
                    </div>


                    <div className="flex m-5 mt-2">
                        <div>
                            <img className="w-7 h-7" src="/assets/icons/contacts-50.png" alt=""/>
                        </div>
                        <Link to="/contacts/"><div className="mx-3 text-base text-gray-100">Prospects</div></Link>
                    </div>
                    {/* 
                    <div className="flex m-5 mt-2">
                        <div>
                            <img className="w-7 h-7" src="/assets/icons/contacts-50.png" alt=""/>
                        </div>
                        <Link to="/cruisecontrol/"><div className="mx-3 text-base text-gray-100">Cruise Control Set up</div></Link>
                    </div>
                    */}

                    <div className="flex m-5 mt-2">
                        <div>
                            <img className="w-7 h-7" src="/assets/icons/analytics.png" alt=""/>
                        </div>
                        <Link to="/analytics/"><div className="mx-3 text-base text-gray-100">Analytics</div></Link>
                    </div>
                </div>
            </nav>
         

       
    );


}